export default "__VITE_ASSET__DuIVjBqP__"